<template>
  <div class="count-box" :style="{ height: height, width: width }">
    <div class="box-row"><div class="title-box">预警事件数</div>
    <div class="value-box">{{chartData.alertCount}}</div>
    </div>
    <div class="box-row"><div class="title-box">预警事件相关数据量</div>
    <div class="value-box">{{chartData.alertAboutCount}}</div></div>
    <div class="box-row"><div class="title-box">负面评价量</div>
    <div class="value-box">{{chartData.badCount}}</div></div>
  </div>
</template>

<script>
  export default {
    name: "Gaojing",
    props: {
      chartData: {
        type: Object,
        default() {
          return {};
        }
      },
      width: {
        type: String,
        default: "300px"
      },
      height: {
        type: String,
        default: "150px"
      }
    },
    components: {
    },
    data() {
      return {};
    },
    mounted() {}
  };
</script>

<style scoped lang="less">
  .count-box {
    width: 100%;
    height: 100%;
    position: relative;
      text-align: left;
  }
    .box-row{position: relative;}
    .title-box,.value-box {display: inline-block;}
  .title-box {
    font-size: 1.3em;
    color: @base-text-color;
      line-height: 0.5rem;
      vertical-align: middle;
  }
  .value-box {
    font-size: 3em;
    font-family: "lcd";
    color: @base-text-color;
      position: absolute;right: 0;top: 0;
      line-height: 1;
  }
</style>